<template>
  <span class="manual">手动</span>
</template>

<script>
export default {

}
</script>

<style lang="stylus" scoped>
.manual
  background rgba(24,150,255, .4)
  color rgba(255,255,255,.8)
  border 1px solid rgba(24,150,255, .6)
  font-size .7rem
  line-height 1.2rem
  padding 0 .5rem
  border-radius .3rem
  margin-left .25rem
</style>
